export default __webpack_public_path__ + "static/media/react-ws-cwa.9dfb8249.md";